import React from "react";
import { Tooltip } from "react-tooltip";
import { toolTipText } from "./ToolTipText";

export function AbstractTooltip({ id, content }: { id: string; content?: string }) {
  content = content ?? toolTipText.find((t) => t.id === id)?.text ?? "";
  return <Tooltip id={id} content={content} delayHide={100} />;
}
